<template>
    <meta name="viewport" content="width=device-width,initial-scale=1.0" />
    <Widget title="Расчет стоимости винтового конвейера" @resize="set_style($event)">
        <WidgetPart>
            <Slider v-model="slide_index" :style="widget_style">
                <!-- расчет стоимости -->
                <Slide index="1" title="Основные параметры" :cur_index="slide_index">
                    <!-- ширина ленты -->
                    <Paragraph title="Тип конвейера">
                        <select class="field short" v-model="auger.type" @change="get_price()" :class="{ 'required disabled': auger.type === undefined }">
                            <option disabled value="undefined" style="display: none; color: grey">Выберите ширину ленты</option>
                            <option v-for="(val, index) in auger.types" :value="index" :key="index">
                                {{ val }}
                            </option>
                        </select>
                    </Paragraph>

                    <!-- тип ленты -->
                    <Paragraph title="Диаметр, мм">
                        <div class="field_container">
                            <select class="field" v-model="auger.diameter" @change="get_price()" :class="{ 'required disabled': !auger.diameter }">
                                <option disabled value="undefined" style="display: none; color: grey">Выберите тип ленты</option>
                                <option v-for="val of auger.diameters" :key="val" :value="val">
                                    {{ val }}
                                </option>
                            </select>
                            <Info style="padding-right: 0px">
                                
                            </Info>
                        </div>
                    </Paragraph>

                    <!-- длина конвейера -->
                    <Paragraph title="Длина, м" style="height: 85px">
                        <input class="field short" :placeholder="`Укажите длину конвейера от ${auger.length_min} до ${auger.length_max} м.`" type="text" v-model="auger.length" @input="get_price()" @change="get_price()" :class="{ required: !auger.length || auger.length == '' }" />
                        <div class="error">{{ length_error_message }}</div>
                    </Paragraph>
                </Slide>

                <!-- итоговое окно для мобильного варианта -->
                <Slide index="2" title="Итог" :cur_index="slide_index">
                    <div class="summary">
                        <!-- Чертежи -->
                        <Paragraph title="Чертежи">
                            <PictureWrapper>
                                <!-- динамический чертеж -->
                                <Picture :url="image_urls(0)" title="Чертеж" width="40%" @click="get_fancy_box(dynamic_draw_url)"></Picture>
                                <!-- внешний вид -->
                                <Picture :url="image_urls(1)" title="Внешний вид" width="40%"></Picture>
                            </PictureWrapper>
                        </Paragraph>

                        <!-- итоговая часть -->
                        <div class="summary_end">
                            <Paragraph title="Получить предложение">
                                <Submit title="Получить" url="https://tulmash.ru/api_new/index.php" :data="submit"></Submit>
                            </Paragraph>
                        </div>
                    </div>
                </Slide>
            </Slider>
            <!-- дубль цены для мобильного варианта -->
            <Paragraph title="Стоимость" class="mobile_only">
                <div class="field price">{{ price_formatted }}</div>
            </Paragraph>
        </WidgetPart>
        <WidgetPart>
            <div class="summary">
                <!-- Чертежи -->
                <Paragraph title="Чертежи">
                    <PictureWrapper>
                        <!-- динамический чертеж -->
                        <Picture :url="image_urls(0)" title="Чертеж" width="40%" @click="get_fancy_box(dynamic_draw_url)"></Picture>
                        <!-- внешний вид -->
                        <Picture :url="image_urls(1)" title="Внешний вид" width="40%"></Picture>
                    </PictureWrapper>
                </Paragraph>

                <!-- итоговая часть -->
                <div class="summary_end">
                    <Paragraph title="Стоимость">
                        <div class="field price ellipsis">{{ price_formatted }}</div>
                    </Paragraph>

                    <Paragraph title="Получить предложение">
                        <Submit title="Получить" url="https://tulmash.ru/api_new/index.php" :data="submit"></Submit>
                    </Paragraph>
                </div>
            </div>
        </WidgetPart>
    </Widget>
</template>

<script>
import axios from "axios";
import * as widget_components from "../../widget_components";

export default {
    name: "App",
    components: widget_components,
    data() {
        return {
            widget_style: undefined,
            slide_index: 1,

            auger: {
                type: undefined,
                diameter: undefined,
                length: undefined,
                length_min: undefined,
                length_max: undefined,
                price: undefined,
                types: undefined,
                diameters: undefined,
                koefficients: undefined,
            },
        };
    },

    computed: {
        length2() {
            let tmp = this.auger.length;
            if (!tmp) return 0;

            tmp = tmp.replaceAll(",", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp * 1;
            return tmp;
        },

        length_error() {
            if (this.auger.length === undefined || this.auger.length == "") return false;
            if (!this.auger.length) return true;
            if (this.auger.length * 1 < this.auger.length_min) return true;
            if (this.auger.length * 1 > this.auger.length_max) return true;
            return false;
        },

        length_error_message() {
            if (!this.auger.length) return "";
            if (this.auger.length * 1 < this.auger.length_min) return `Минимальная длина конвейера - ${this.auger.length_min} метра`;
            if (this.auger.length * 1 > this.auger.length_max) return `Максимальная длина конвейера - ${this.auger.length_max} метров`;
            return "";
        },

        price_formatted() {
            if (this.auger.type === undefined) return "-";
            if (this.auger.diameter === undefined) return "-";
            if (!this.length2) return "-";

            let formatter = new Intl.NumberFormat("ru-RU", {
                style: "currency",
                currency: "RUB",
            });

            return "от " + formatter.format(this.auger.price);
        },

        // датнные для получения КП
        submit() {
            if (!this.data_is_ready_to_send()) return undefined;

            return {
                mode: "get_auger_kp",
                type: this.auger.type,
                length: this.auger.length,
                diameter: this.auger.diameter,
                price: this.auger.price,
            };
        },
    },

    mounted() {
        axios.get("https://tulmash.ru/api_new/?mode=get_auger_data&tm=" + new Date()).then((response) => {
            this.auger = response.data.auger;            
        });
    },

    methods: {
        image_urls(index) {
            let urls = [
                "https://tulmash.ru/wp-content/uploads/2021/09/%D1%86%D0%B8%D0%BB%D0%B8%D0%BD%D0%B4%D1%80%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9%20%D1%88%D0%BD%D0%B5%D0%BA.png",
                "https://tulmash.ru/wp-content/webpc-passthru.php?src=https://tulmash.ru/wp-content/uploads/2022/03/Foto-oborudovaniya_osnovnoe-Vosstanovlen4-1280x720.jpg",
            ];

            return urls[index];
        },

        set_style(e) {
            this.widget_style = e.style;
        },

    
        data_is_ready_to_send() {            
            if (this.auger.type === undefined) return false;
            if (this.auger.diameter === undefined) return false;
            if (!this.length2) return false;            
            return true;
        },

        get_price: function () {
            // проверяем корректность данных перед отправкой
            if (!this.data_is_ready_to_send()) return (this.auger.price = "-");

            
            let params = {
                mode: "get_auger_price",
                type: this.auger.type,
                diameter: this.auger.diameter,
                length: this.auger.length,
                tm: new Date(),
            };            

            let formData = new FormData();
            for (let key in params) {
                let param = params[key];
                if (typeof param == "object") {
                    param = JSON.stringify(param);
                }
                formData.append(key, param);
            }

            axios
                .post("https://tulmash.ru/api_new/index.php", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {  
                    console.log(response)                 

                    this.auger.price = response.data.data;
                });
        },
    },
};
</script>

<style>
</style>

<style scoped>
.summary {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.summary_end {
    margin-top: auto;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
}


.field_container {
    display: flex;
    justify-content: flex-start;
}

.price {
    font-weight: bold;
    text-align: center;
    background: none;

    margin: 0 !important;
    width: auto;

    box-shadow: none;
    border-radius: 0px;
    color: black;
}

.error {
    color: red;
}


.widget.desktop .mobile_only{
    display: none;
}

</style>
